<template>
    <div class="menu">
        <div class="l">
            <div class="title">
                菜单
                
                <el-button type="primary"  size="mini" @click='addMenu=true' >新增</el-button>
            </div>
            <div class="l-m">
                <el-tree :data="menuList" node-key="id" @node-click="handleNodeClick" :props="defaultProps" :default-expand-all="false" :expand-on-click-node="false"></el-tree>
            </div>
        </div>
        <div class="c">
            <div class="title">
                资源详情 {{selectItem.name?'【'+selectItem.name+'】':'(请点击选择左侧菜单)'}}
                <div>
                    <el-button type="danger" size="mini" @click="deleteMenu">删除</el-button>
                    <el-button type="primary" size="mini" @click="updateMenu">保存编辑</el-button>
                </div>
            </div>
            <div class="c-m">
                <div class="item">
                    <div class="label">
                        资源名称:
                    </div>
                    <el-input v-model="selectItem.name" placeholder="请输入资源名称" size="small"></el-input>
                </div>
                <div class="item">
                    <div class="label">
                        类型:
                    </div>
                    <div class="value" v-if="selectItem.type == 1">
                        模块
                    </div>
                    <div class="value" v-else-if="selectItem.type == 2">
                        页面
                    </div>
                    <div class="value" v-else>
                        暂无
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        图标:
                    </div>
                    <div class="value item-img" v-if="selectItem.icon">
                        <i :class="selectItem.icon"></i>
                    </div>
                    <div class="value" v-else>
                        <div>无</div>
                    </div>
                </div>
                
                <div class="item">
                    <div class="label">
                        父级菜单:
                    </div>
                    <el-select v-model="selectItem.parentId" clearable placeholder="请选择父级菜单" size="small" v-if="selectItem.type == 2">
                        <el-option
                        v-for="item in parentList"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                        </el-option>
                    </el-select>
                    <div class="value" v-else>
                        无
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        菜单路劲:
                    </div>
                    <el-input v-model="selectItem.path" placeholder="请输入菜单路劲" size="small"></el-input>
                </div>
                <div class="item">
                    <div class="label">
                        排序号:
                    </div>
                    <el-input v-model="selectItem.sortId" placeholder="请输入排序号" size="small"></el-input>
                </div>
                <div class="item">
                    <div class="label">
                        备注:
                    </div>
                    <el-input type="textarea" v-model="selectItem.name" placeholder="请输入备注" size="small" style="width:400px;"></el-input>
                </div>
                <!-- <div class="item">
                    <div class="label">
                        是否启用:
                    </div>
                    <el-switch
                        v-model="value"
                        >
                    </el-switch>
                </div> -->
            </div>
        </div>
        <div class="r">
            <div class="title">
                权限
                <el-button type="primary" size="mini" @click="addBtn = true" v-if="selectItem.type==2">新增</el-button>
            </div>
            <div class="r-m" v-if="selectItem.type==2">
                <!-- <div class="item">
                    <div class="r-m-l">
                        <i class="el-icon-edit"></i>
                        修改
                    </div>
                    <div class="r-m-r">
                        <div class="r-bl">
                            <i class="el-icon-edit"></i>
                        </div>
                        <div class="r-br">
                            <i class="el-icon-delete"></i>
                        </div>
                    </div>
                </div>

                <div class="item">
                    <div class="r-m-l">
                        <i class="el-icon-circle-plus-outline"></i>
                        新增
                    </div>
                    <div class="r-m-r">
                        <div class="r-bl">
                            <i class="el-icon-edit"></i>
                        </div>
                        <div class="r-br">
                            <i class="el-icon-delete"></i>
                        </div>
                    </div>
                </div>

                <div class="item">
                    <div class="r-m-l">
                        <i class="el-icon-delete"></i>
                        删除
                    </div>
                    <div class="r-m-r">
                        <div class="r-bl">
                            <i class="el-icon-edit"></i>
                        </div>
                        <div class="r-br">
                            <i class="el-icon-delete"></i>
                        </div>
                    </div>
                </div>

                <div class="item">
                    <div class="r-m-l">
                        <i class="el-icon-upload"></i>
                        导入
                    </div>
                    <div class="r-m-r">
                        <div class="r-bl">
                            <i class="el-icon-edit"></i>
                        </div>
                        <div class="r-br">
                            <i class="el-icon-delete"></i>
                        </div>
                    </div>
                </div>

                <div class="item">
                    <div class="r-m-l">
                        <i class="el-icon-download"></i>
                        导出
                    </div>
                    <div class="r-m-r">
                        <div class="r-bl">
                            <i class="el-icon-edit"></i>
                        </div>
                        <div class="r-br">
                            <i class="el-icon-delete"></i>
                        </div>
                    </div>
                </div> -->

                <div class="item" v-for="(item,index) in selectItem.children" :key="index">
                    <div class="r-m-l">
                        <i :class="item.icon"></i>
                        {{item.name}}
                    </div>
                    <div class="r-m-r">
                        <!-- <div class="r-bl">
                            <i class="el-icon-edit"></i>
                        </div> -->
                        <div class="r-br" @click="deleteBtn(item,index)">
                            <i class="el-icon-delete"></i>
                        </div>
                    </div>
                </div>
            </div>
        </div>



        <el-dialog title="新增菜单" :visible.sync="addMenu" width="800px">
            <div class="dialog-add">
                <div class="item">
                    <div class="label">
                        类型:
                    </div>
                    <el-select v-model="addMenuData.type" size="small" placeholder="请选择新增类型">
                        <el-option
                        v-for="item in typeList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                        </el-option>
                    </el-select>
                </div>
                <div class="item">
                    <div class="label">
                        资源名称:
                    </div>
                    <el-input v-model="addMenuData.name" placeholder="请输入资源名称" size="small"></el-input>
                </div>
            
                <div class="item">
                    <div class="label">
                        图标:
                    </div>
                    <div class="icon" v-if="addMenuData.icon">
                        <i :class="addMenuData.icon"></i>
                    </div>
                    <el-button type="primary" size="mini" @click="menuIconDialog = true">选择</el-button>
                </div>
            
                <div class="item">
                    <div class="label">
                        资源路劲:
                    </div>
                    <el-input v-model="addMenuData.path" placeholder="请输入菜单路劲" size="small"></el-input>
                </div>
           
                <div class="item" v-if="addMenuData.type == 2">
                    <div class="label">
                        父级菜单:
                    </div>
                    <el-select v-model="addMenuData.parentId" clearable placeholder="请选择父级菜单" size="small">
                        <el-option
                        v-for="item in parentList"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                        </el-option>
                    </el-select>
                </div>

                <div class="item">
                    <div class="label">
                        排序号:
                    </div>
                    <el-input v-model="addMenuData.sortId" placeholder="请输入排序号" size="small"></el-input>
                </div>
                <!-- <div class="item">
                    <div class="label">
                        备注:
                    </div>
                    <el-input type="textarea" v-model="addMenuData.remark" placeholder="请输入备注" size="small" style="width:400px"></el-input>
                </div>
                <div class="item">
                    <div class="label">
                        是否启动:
                    </div>
                    <el-switch
                        v-model="addMenuData.isSelect"
                        >
                    </el-switch>
                </div> -->
            </div>
            <div class="btns">
                <el-button @click="addMenu=false">取消</el-button>
                <el-button type="primary" @click="createResource()">确定新增</el-button>
            </div>
        </el-dialog>



        <el-dialog title="新增操作权限" :visible.sync="addBtn" width="800px">
            <div class="dialog-add">
                <div class="item">
                    <div class="label">
                        操作名称:
                    </div>
                    <el-input v-model="addMenuBtnData.name" placeholder="请输入操作名称" size="small"></el-input>
                </div>
            
                <div class="item">
                    <div class="label">
                        图标:
                    </div>
                    <div class="iconb" v-if="addMenuBtnData.icon">
                        <i :class="addMenuBtnData.icon"></i>
                    </div>
                    <el-button type="primary" size="mini" @click="btnIconDialog=true">选择</el-button>
                </div>
            

                <div class="item">
                    <div class="label">
                        排序号:
                    </div>
                    <el-input v-model="addMenuBtnData.sortId" placeholder="请输入排序号" size="small"></el-input>
                </div>
                <!-- <div class="item">
                    <div class="label">
                        备注:
                    </div>
                    <el-input type="textarea" v-model="addMenuData.remark" placeholder="请输入备注" size="small" style="width:400px"></el-input>
                </div>
                <div class="item">
                    <div class="label">
                        是否启动:
                    </div>
                    <el-switch
                        v-model="addMenuData.isEable"
                        >
                    </el-switch>
                </div> -->
            </div>
            <div class="btns">
                <el-button @click="addBtn=false">取消</el-button>
                <el-button type="primary" @click="addBtnClick">确定新增</el-button>
            </div>
        </el-dialog>
        

        <el-dialog title="图标选择" :visible.sync="menuIconDialog" width="400px">
            <!-- <div class="icons">
                <div class="item" v-for="(item,index) in imgs" :key="index" @click="selectMenuIcon(item)">
                    <img :src="item" alt="">
                </div>
            </div> -->
            <div class="iconsb">
                <div class="item" @click="selectMenuIcon('el-icon-setting')">
                    <i class="el-icon-setting"></i>
                </div>
                <div class="item" @click="selectMenuIcon('el-icon-s-management')">
                    <i class="el-icon-s-management"></i>
                </div>
                <div class="item" @click="selectMenuIcon('el-icon-s-home')">
                    <i class="el-icon-s-home"></i>
                </div>
                <div class="item" @click="selectMenuIcon('el-icon-s-help')">
                    <i class="el-icon-s-help"></i>
                </div>
                <div class="item" @click="selectMenuIcon('el-icon-video-camera-solid')">
                    <i class="el-icon-video-camera-solid"></i>
                </div>
                <div class="item" @click="selectMenuIcon('el-icon-s-platform')">
                    <i class="el-icon-s-platform"></i>
                </div>
                <div class="item" @click="selectMenuIcon('el-icon-s-shop')">
                    <i class="el-icon-s-shop"></i>
                </div>
                <div class="item" @click="selectMenuIcon('el-icon-s-marketing')">
                    <i class="el-icon-s-marketing"></i>
                </div>
                <div class="item" @click="selectMenuIcon('el-icon-s-custom')">
                    <i class="el-icon-s-custom"></i>
                </div>
                <div class="item" @click="selectMenuIcon('el-icon-s-data')">
                    <i class="el-icon-s-data"></i>
                </div>
                <div class="item" @click="selectMenuIcon('el-icon-office-building')">
                    <i class="el-icon-office-building"></i>
                </div>
                <div class="item" @click="selectMenuIcon('el-icon-edit')">
                    <i class="el-icon-edit"></i>
                </div>
                <div class="item" @click="selectMenuIcon('el-icon-truck')">
                    <i class="el-icon-truck"></i>
                </div>
            </div>
        </el-dialog>
        <el-dialog title="图标选择" :visible.sync="btnIconDialog" width="300px">
            <div class="iconsb">
                <div class="item" @click="selectBtnIcon('el-icon-edit')">
                    <i class="el-icon-edit"></i>
                </div>
                <div class="item" @click="selectBtnIcon('el-icon-circle-plus-outline')">
                    <i class="el-icon-circle-plus-outline"></i>
                </div>
                <div class="item" @click="selectBtnIcon('el-icon-delete')">
                    <i class="el-icon-delete"></i>
                </div>
                <div class="item" @click="selectBtnIcon('el-icon-upload')">
                    <i class="el-icon-upload"></i>
                </div>
                <div class="item" @click="selectBtnIcon('el-icon-download')">
                    <i class="el-icon-download"></i>
                </div>
            </div>
        </el-dialog>
      
        
    </div>
</template>
<script>
import api from '../../../api/main'
export default {
    name: 'menu',
    data () {
        return {
            name:'',
            menuList:[],
            addMenu:false,
            addMenuBtnData:{},
            addMenuData:{
                type:1,
            },
            addBtn:false,
            isEdit:false,
            value: '',
            parentList: [],
            defaultProps: {
                children: 'children',
                label: 'name'
            },
            list:[],//经过处理的菜单列表
            selectItem:{
                children:[]
            },//选中的菜单
            typeList:[
                {
                    'label':'菜单',
                    'value':1
                },{
                    'label':'页面',
                    'value':2
                }
            ],
            menuIconDialog:false,
            btnIconDialog:false,
            imgs:[
                'http://txggpic.oss-cn-shenzhen.aliyuncs.com/20210326/20210326152722niMXY.jpg',
                'http://txggpic.oss-cn-shenzhen.aliyuncs.com/20210326/20210326152722Qj6PY.jpg',
                'http://txggpic.oss-cn-shenzhen.aliyuncs.com/20210326/20210326152722yHKe6.jpg',
                'http://txggpic.oss-cn-shenzhen.aliyuncs.com/20210326/20210326152722AkezC.jpg',
                'http://txggpic.oss-cn-shenzhen.aliyuncs.com/20210326/20210326152722hQhYQ.jpg',
                'http://txggpic.oss-cn-shenzhen.aliyuncs.com/20210326/20210326152722DEPRP.jpg',
                'http://txggpic.oss-cn-shenzhen.aliyuncs.com/20210326/20210326152722iRBjx.jpg',
                'http://txggpic.oss-cn-shenzhen.aliyuncs.com/20210326/20210326152722w7FkT.jpg',
                'http://txggpic.oss-cn-shenzhen.aliyuncs.com/20210326/20210326152722aZaxK.jpg',
                'http://txggpic.oss-cn-shenzhen.aliyuncs.com/20210326/20210326152722AHX3Y.jpg',
                'http://txggpic.oss-cn-shenzhen.aliyuncs.com/20210326/20210326152722wDefb.jpg',
                'http://txggpic.oss-cn-shenzhen.aliyuncs.com/20210326/20210326152722w6YmE.jpg',
                'http://txggpic.oss-cn-shenzhen.aliyuncs.com/20210326/20210326152722c4KRx.jpg',

            ],
        }
    },
    created(){
        this.queryMenu();
        this.queryIconPath();
    },
    mounted(){
    },
    methods:{
        async handleNodeClick(data,node){
            console.log(data);
            console.log(node);
            let _this = this;
            if(data.type == 1){
                this.selectItem = data;
            } else if(data.type == 2){
                this.selectItem = data;
                data.children.forEach((element,eleIndex) => {
                    console.log(element);
                    if(element.id == node.parent.data.id){
                        // element.children.forEach((val,index) => {
                        //     if(data.id == val.id){
                        //         _this.selectItem = val;
                        //     }
                        // })
                    }
                });
            }
           
        },
        async queryMenu(){
            let res  = await api.queryResource();
            this.menuList = res.data.data;
            let list = res.data.data;
            console.log(list);
            this.parentList = [];
            list.forEach((element,eleIndex) => {
                console.log(element);
                console.log(eleIndex);
                this.parentList.push({
                    'id':list[eleIndex].id,
                    'name':list[eleIndex].name,
                })
                // element.children.forEach((val,index) => {
                //     list[eleIndex].children[index].children = []
                // })
            });
            this.list = list;
        },
        // 选择图标列表
        async queryIconPath(){
            let res  = await api.QueryIconPath();
            console.log(res);
            this.imgs = res.data.result;
        },
        // 选中图标
        selectMenuIcon(path){
            this.menuIconDialog = false;
            this.addMenuData.icon = path
        },
        selectBtnIcon(icon){
            console.log(icon);
            this.btnIconDialog = false;
            this.addMenuBtnData.icon = icon;
            this.$forceUpdate();
        },
        // 添加后台资源
        async createResource(){
            this.addMenuData.sortId = parseInt(this.addMenuData.sortId);
            let res  = await api.createResource(this.addMenuData);
            if(res.data.code == '200'){
                this.$message({
                    message: '添加成功',
                    type: 'success'
                });
                this.queryMenu();
                this.addMenu = false;
            }
        },
        async updateMenu(){
            console.log(this.selectItem);
            this.selectItem.sortId = parseInt(this.selectItem.sortId);
            let res  = await api.updateResource(this.selectItem);
            if(res.data.code == '200'){
                this.$message({
                    message: '编辑成功',
                    type: 'success'
                });
                this.queryMenu();
                this.addMenu = false;
            }
        },
        // 删除菜单
        async deleteMenu(){
            if(this.selectItem.id){
                this.$confirm('将删除选中资源, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.deleteMenuFun(this.selectItem.id);
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });          
                });
                
            }
        },
        // 删除菜单接口
        async deleteMenuFun(id){
            let res  = await api.deleteResource(id);
            if(res.data.code == '200'){
                this.$message({
                    type: 'success',
                    message: '删除成功!'
                });
            }
            this.selectItem = {};
            this.queryMenu();
            
        },
        
        // 添加按钮
        async addBtnClick(){
            this.addMenuBtnData.type = 3;
            this.addMenuBtnData.parentId = this.selectItem.id;
            this.addMenuBtnData.sortId = parseInt(this.addMenuBtnData.sortId);
            console.log(this.addMenuBtnData);
            let res  = await api.createResource(this.addMenuBtnData);
            if(res.data.code == '200'){
                this.$message({
                    message: '添加成功',
                    type: 'success'
                });
                this.queryMenuDetail();
                this.addBtn = false;
                
            }
        },
        // 查看详情
        async queryMenuDetail(){
            let res  = await api.queryResource();
            this.menuList = res.data.data;
            console.log(this.menuList);
            for(let index in this.menuList){
                for(let cindex in this.menuList[index].children){
                    if(this.menuList[index].children[cindex].id == this.selectItem.id){
                        this.selectItem = this.menuList[index].children[cindex]
                    }
                    
                }
            }
        },
        // 删除按钮
        async deleteBtn(item,index){
            let res  = await api.deleteResource(item.id);
            if(res.data.code == '200'){
                this.$message({
                    type: 'success',
                    message: '删除成功!'
                });
                this.selectItem.children.splice(index,1)
            }
        },
    }
    
}
</script>

<style lang="scss" scoped>
    .menu{
        background-color: #ffffff;
        display: flex;
        justify-content: space-between;
        .l{
            width: 270px;
            border-right: 1px solid #DEDEDE;
            .title{
                font-size: 15px;
                height: 50px;
                border-bottom: 1px solid #DEDEDE;
                padding-left: 20px;
                display: flex;
                align-items: center;
                justify-content: space-between;
                padding-right: 12px;
            }
            .l-m{
                padding: 20px;
                padding-bottom: 25px;
                /deep/.el-tree{
                    color: #000000;
                    /deep/.el-tree-node:focus>.el-tree-node__content {
                        background-color: #ecf5ff;
                        color: #1989fa;
                    }
                    .el-tree-node__content{
                        padding: 5px 0;
                        .el-tree-node__expand-icon{
                            color:#606266
                        }
                    }
                    
                }
            }
        }
        .c{
            flex: auto;
            border-right: 1px solid #DEDEDE;
            
            .title{
                font-size: 15px;
                height: 50px;
                display: flex;
                align-items: center;
                border-bottom: 1px solid #DEDEDE;
                padding-left: 20px;
                display: flex;
                align-items: center;
                justify-content: space-between;
                padding-right: 12px;
            }
            .c-m{
                padding: 20px 0;
                display: flex;
                flex-direction: column;
                .item{
                    display: flex;
                    font-size: 14px;
                    min-height: 32px;
                    margin: 10px 0;
                    display: flex;
                    align-items: center;
                    margin-left: 25%;
                    color: #000000;
                    .label{
                        width: 100px;
                        text-align: right;
                        margin-right: 5px;
                        color: #38393a;
                    }
                    .el-input{
                        color: #000000;
                        width: 300px;
                    }
                    .value{
                        margin-left: 10px;
                        
                    }
                    .item-img{
                        width: 40px;
                        height: 40px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        border:1px solid #2f2e2e;
                        border-radius: 4px;
                        margin-right: 8px;
                        font-size: 18px;
                    }
                }
            }
        }
        .r{
            width: 300px;
            .title{
                font-size: 15px;
                height: 50px;
                display: flex;
                align-items: center;
                border-bottom: 1px solid #DEDEDE;
                padding-left: 20px;
                display: flex;
                align-items: center;
                justify-content: space-between;
                padding-right: 12px;
            }
            .r-m{
                display: flex;
                flex-direction: column;
                align-items: center;
                .item{
                    width: 280px;
                    height: 55px;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    border: 1px solid #eee;
                    border-radius: 5px;
                    box-shadow: 0 1px 2px rgba(0,0,0,.17);
                    margin-top: 10px;
                    .r-m-l{
                        font-size: 14px;
                        display: flex;
                        align-items: center;
                        i{
                            font-size: 18px;
                            margin: 10px;
                        }
                    }
                    .r-m-r{
                        margin-right: 15px;
                        display: flex;
                        div{
                            border: 1px solid #222222;
                            border-radius: 3px;
                            margin-left: 5px;
                            padding: 0 2px;
                            cursor: pointer;
                        }
                    }
                }
            }
        }
        
        
        .dialog-add{
            display: flex;
            flex-direction: column;
            .item{
                display: flex;
                align-items: center;
                margin-left: 10%;
                margin-bottom: 20px;
                .label{
                    width: 150px;
                    text-align: right;
                    margin-right: 20px;
                }
                .icon{
                    width: 40px;
                    height: 40px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    border-radius: 4px;
                    margin-right: 8px;
                    font-size: 18px;
                }
                .iconb{
                    width: 40px;
                    height: 40px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    color: #000000;
                    font-size: 18px;
                    border-radius: 4px;
                    margin-right: 8px;
                }
                .el-input{
                    width: 300px;
                }
            }
        }
        .btns{
            width: 100%;
            display: flex;
            justify-content: center;
        }
        
        .icons{
            display: flex;
            flex-wrap: wrap;
            .item{
                width: 40px;
                height: 40px;
                display: flex;
                align-items: center;
                justify-content: center;
                background-color: #2f2e2e;
                border-radius: 4px;
                margin-right: 8px;
                margin-bottom: 8px;
                cursor: pointer;
            }
            .item:hover{
                background-color: #409EFF;
            }
        }
        .iconsb{
            display: flex;
            flex-wrap: wrap;
            .item{
                width: 40px;
                height: 40px;
                display: flex;
                align-items: center;
                justify-content: center;
                border:1px solid #2f2e2e;
                border-radius: 4px;
                margin: 0px 5px;
                margin-bottom: 8px;
                cursor: pointer;
                font-size: 18px;
                color: #000000;
            }
            .item:hover{
                border:1px solid #409EFF;
                background-color: #409EFF;
                color: #ffffff;
            }
        }
    }
</style>
